import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'elasticsearch',
  name: 'Elasticsearch',
  category: 'database',
  description: 'Search, index, and manage documents in Elasticsearch. Supports full-text search, document CRUD, and index management.',
  icon: 'siElasticsearch',
  iconType: 'simple-icon',
  color: 'teal',
  version: '1.0.0',
  group: ['transform'],
  defaults: {
    name: 'Elasticsearch',
    color: '#005571',
  },
  credentials: [
    {
      name: 'elasticsearchApi',
      required: true,
      displayName: 'Elasticsearch API',
    },
  ],
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true,
    },
  ],
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output',
    },
  ],
  tags: ['elasticsearch', 'search', 'index', 'query', 'nosql', 'full-text'],
  comingSoon: false,

  // Tool-capable configuration for AI Agent
  toolCapable: {
    enabled: true,
    name: 'elasticsearch_search',
    description: 'Search and manage documents in Elasticsearch. Supports full-text search using Query DSL, document CRUD operations (create, read, update, delete, bulkIndex), and index management (create, delete, exists, getMapping).',
    allowManualDescription: true,
    parameters: {
      resource: {
        toolParamName: 'resource',
        description: 'The resource to operate on: document or index',
        required: true,
        type: 'string',
      },
      operation: {
        toolParamName: 'operation',
        description: 'The operation: create, delete, get, getAll, update, bulkIndex (document) or create, delete, get, getAll, indexExists, getMapping (index)',
        required: true,
        type: 'string',
      },
      indexId: {
        toolParamName: 'index',
        description: 'The name of the Elasticsearch index',
        required: true,
        type: 'string',
      },
      documentId: {
        toolParamName: 'document_id',
        description: 'The document ID (for single document operations)',
        required: false,
        type: 'string',
      },
      query: {
        toolParamName: 'query',
        description: 'Elasticsearch Query DSL as JSON (for search operations)',
        required: false,
        type: 'string',
      },
      sourceArray: {
        toolParamName: 'sourceArray',
        description: 'Source array data for bulkIndex operation',
        required: false,
        type: 'array',
      },
      idField: {
        toolParamName: 'idField',
        description: 'Field name to use as document ID for bulkIndex (optional)',
        required: false,
        type: 'string',
      },
    },
    outputMapping: {
      documents: 'Array of matching documents',
      total: 'Total number of matching documents',
      result: 'The operation result (created, updated, deleted)',
      exists: 'Whether the index exists (for indexExists)',
      mapping: 'Index field mappings (for getMapping)',
      indexed: 'Number of documents indexed (for bulkIndex)',
    },
  },
};

export default definition;
